import { z } from 'zod';
export var CustomProfileFieldType;
(function (CustomProfileFieldType) {
    /* Primitive types */
    CustomProfileFieldType["Text"] = "Text";
    CustomProfileFieldType["Number"] = "Number";
    CustomProfileFieldType["Date"] = "Date";
    CustomProfileFieldType["Checkbox"] = "Checkbox";
    CustomProfileFieldType["Select"] = "Select";
    CustomProfileFieldType["Url"] = "Url";
    CustomProfileFieldType["Regex"] = "Regex";
    /* Composite types */
    CustomProfileFieldType["Address"] = "Address";
    CustomProfileFieldType["Fullname"] = "Fullname";
})(CustomProfileFieldType || (CustomProfileFieldType = {}));
export const customProfileFieldTypeGuard = z.nativeEnum(CustomProfileFieldType);
export const fieldOptionGuard = z.object({
    label: z.string(),
    value: z.string(),
});
export const fieldOptionsGuard = fieldOptionGuard.array();
export const fieldPartGuard = z.object({
    key: z.string(),
    enabled: z.boolean(),
});
export const fieldPartsGuard = fieldPartGuard.array();
export const customProfileFieldConfigGuard = z.object({
    placeholder: z.string().max(256).optional(),
    minLength: z.number().int().optional(),
    maxLength: z.number().int().optional(),
    minValue: z.number().int().optional(),
    maxValue: z.number().int().optional(),
    format: z.string().max(128).optional(),
    options: fieldOptionsGuard.optional(),
    parts: fieldPartsGuard.optional(),
});
